import getSymbolFromCurrency from 'currency-symbol-map';

if (getSymbolFromCurrency && getSymbolFromCurrency.currencySymbolMap) {
    getSymbolFromCurrency.currencySymbolMap.BCH = '₿';
    getSymbolFromCurrency.currencySymbolMap.USDT = '₮';
    getSymbolFromCurrency.currencySymbolMap.USDC = '$';
}
